import React from 'react';
import { Modal, ModalWrapper, ThemeProvider } from '@workboard/wobo-ui';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const StyledModal = styled(Modal)`
  ${ModalWrapper} {
    min-height: 368px;
    width: 933px;
    .memberPopupContent {
      font-size: 13px;
    }
  }
`;

type Props = {
  workload: {
    workloadDetails: {
      startDate: string,
      endDate: string,
      totalWeeks: number,
      totalWeeksInt: number,
      filterUserList: any[],
    }
  },
  userId?: string,
  userName?: string,
  onClose: Function,
};

const MemberCapacity = (props: Props) => {
  const { t } = useTranslation();
  const round = (value, precision) => {
    const multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
  }

  const constructWSData = (_m, item, _inWeek) => {
    let bandwidth = {};
    let ws_id;
    let ws_name = '';
    let priority_low = 0;
    let priority_medium = 0;
    let priority_high = 0;
    let doing_state = 0;
    let next_state = 0;
    let pause_state = 0;
    let
      done_state = 0;
    ws_id = _m.wsId;
    ws_name = _m.tag_name;
    // console.log(item);
    if (typeof item !== 'undefined') {
      priority_low = item.doing_state.low;
      priority_medium = item.doing_state.medium;
      priority_high = item.doing_state.high;
      doing_state = item.doing_state.count;
      pause_state = item.pause_state;
      next_state = item.next_state;
      done_state = item.done_state;
    }
    // console.log(_inWeek);
    if (_m.state == '1') {
      doing_state += _inWeek;
      if (_m.priority == '3') {
        priority_low += _inWeek;
      } else if (_m.priority == '2') {
        priority_medium += _inWeek;
      } else if (_m.priority == '1') {
        priority_high += _inWeek;
      }
    } else if (_m.state == '0') {
      done_state += _inWeek;
    } else if (_m.state == '2') {
      next_state += _inWeek;
    } else if (_m.state == '4') {
      pause_state += _inWeek;
    }
    bandwidth = {
      ws_id,
      ws_name,
      done_state,
      next_state,
      pause_state,
      doing_state: {
        count: doing_state, high: priority_high, medium: priority_medium, low: priority_low,
      },
    };
    // console.log(bandwidth);

    return bandwidth;
  }

  const getBusinessDatesCount = (startDate, endDate, _timeoff) => {
    const timeoff = _timeoff || [];
    // console.log(timeoff);
    let count = 0;
    const curDate = startDate;

    while (curDate <= endDate) {
      const dayOfWeek = curDate.getDay();
      // console.log(timeoff.indexOf(+curDate));
      if (!((dayOfWeek == 6) || (dayOfWeek == 0) || timeoff.indexOf(+curDate) > -1)) {
        count++;
      }
      curDate.setDate(curDate.getDate() + 1);
    }
    return count;
  }

  const userId = props.userId || false;
  let userName = props.userName || '';
  let _wsData;
  const _wsId = [];
  let _wsDataFullData;
  let _allocatedWeek = 0;
  let _availableWeek = 0;
  const _workloadDetails = props.workload.workloadDetails;
  let priority_high = 0;
  let priority_medium = 0;
  let priority_low = 0;
  let doing_state = 0;
  let done_state = 0;
  let pause_state = 0;
  let next_state = 0;
  let total_item = 0;

  if (userId) {
    _workloadDetails.filterUserList.map((item) => {
      if (userId == item.id) {
        _wsData = item;
      }
    });
    _allocatedWeek = parseFloat(_wsData.weeks) || 0;
    _wsDataFullData = _wsData.userWsWorkload || [];
    const _timeoff = _wsData.timeoff;

    if (Object.keys(_wsDataFullData).length) {
      _wsDataFullData = Object.keys(_wsDataFullData).map((_tasks_data_key) => {
        const _tasks_data = _wsDataFullData[_tasks_data_key];
        let _m = [];
        let _inWeek;
        let i = 0;
        _tasks_data.map((_tasks1) => {
          if (_m.length) {
            let checked = 0;
            for (let j = 0; j < _m.length; j++) {
              if (_tasks1.start <= _m[j].end && _m[j].start <= _tasks1.end) {
                checked = 1;
                _m[j].start = Math.min(_m[j].start, _tasks1.start);
                _m[j].end = Math.max(_m[j].end, _tasks1.end);
                if (_tasks1.end == _m[j].end) {
                  _m[j].id = _tasks1.id;
                  _m[j].state = _tasks1.state;
                  _m[j].priority = _tasks1.priority;
                  _m[j].wsId = _tasks1.wsId;
                  _m[j].tag_name = _tasks1.tag_name;
                }
              }
            }
            // console.log("end" + checked);
            if (checked == 0) {
              _m[i] = {
                id: _tasks1.id,
                start: _tasks1.start,
                end: _tasks1.end,
                state: _tasks1.state,
                priority: _tasks1.priority,
                wsId: _tasks1.wsId,
                tag_name: _tasks1.tag_name,
              };
              i += 1;
            }
          } else {
            _m[i] = {
              id: _tasks1.id,
              start: _tasks1.start,
              end: _tasks1.end,
              state: _tasks1.state,
              priority: _tasks1.priority,
              wsId: _tasks1.wsId,
              tag_name: _tasks1.tag_name,
            };
            i += 1;
          }

          return _tasks1;
        });
        const _tem = [];
        const temp = [];
        i = 0;
        if (_m.length) {
          // console.log(_m);
          _m.map((_tasks1) => {
            if (temp.length) {
              let checked = 0;
              let
                j = 0;
              // console.log(temp);
              for (j = 0; j < temp.length; j++) {
                if (_tasks1.start <= temp[j].end && temp[j].start <= _tasks1.end) {
                  checked = 1;
                  temp[j].start = Math.min(temp[j].start, _tasks1.start);
                  temp[j].end = Math.max(temp[j].end, _tasks1.end);
                  if (_tasks1.end == temp[j].end) {
                    temp[j].id = _tasks1.id;
                    temp[j].state = _tasks1.state;
                    temp[j].priority = _tasks1.priority;
                    temp[j].wsId = _tasks1.wsId;
                    temp[j].tag_name = _tasks1.tag_name;
                  }
                }
              }
              if (checked == 0) {
                temp[i] = _tasks1;
                i += 1;
              }
            } else {
              temp[i] = _tasks1;
              i += 1;
            }
          });
        }
        _m = temp;
        for (let k = 0; k < _m.length; k++) {
          // console.log(_tem)
          if ($.inArray(`${_m[k].start}_${_m[k].end}`, _tem) > -1) {
            continue;
          }
          _tem.push(`${_m[k].start}_${_m[k].end}`);
          _m[k].days = getBusinessDatesCount(new Date(_m[k].start * 1000), new Date(_m[k].end * 1000), _timeoff);

          _inWeek = (_m[k].days / 5);
          if (_wsId.length) {
            _wsId[_m[k].wsId] = constructWSData(_m[k], _wsId[_m[k].wsId], _inWeek);
          } else {
            _wsId[_m[k].wsId] = constructWSData(_m[k], undefined, _inWeek);
          }
        }
      });
    }
    _wsData = _wsId;
    // console.log(_wsData);
    _availableWeek = _workloadDetails.totalWeeksInt - _allocatedWeek;
    if (_availableWeek < 0) {
      _availableWeek = 0;
    } else {
      _availableWeek = round(_availableWeek, 1);
    }
  }
  // console.log(_wsData);
  if (userName.charAt(userName.length - 1) == 's') {
    userName = userName.substr(0, userName.length - 1);
  }

  const Toolbar = () => (
    <span className="memberDate">
      {_workloadDetails.totalWeeks}: {_workloadDetails.startDate} to {_workloadDetails.endDate}
    </span>
  );

  return (
    <ThemeProvider>
      <StyledModal
        isOpen={true}
        kind="normal"
        title={(userName == '') ? t('Weeks of Work') : `${userName}'s Bandwidth`}
        toolbar={Toolbar}
        disableDismiss
        disableSubmit
        onDismiss={props.onClose}
        disableScrollLock={true}
      >
        <div className="memberPopup">
          <div className="memberPopupContent">
            <div className="dispInBk">
              <div className="allottedWidth dispInBk">
                {userId && 'Allocated'}
                {' '}
              </div>
              <div className="avilabledWidth dispInBk">
                {' '}
                {userId && 'Available'}
                {' '}
              </div>
              <div className="progressWidth  dispInBk">{t('In progress')}</div>
              <div className="widthEmpty dispInBk"/>
            </div>
            <div className="dispInBk">
              <div className=" allottedWidth allottedBorder dispInBk totalItems boardBottom">
                <div className="updateValue">{userId && _allocatedWeek}</div>
                <div className="wksClass">{userId && 'wks'}</div>
              </div>
              <div className=" avilabledWidth allottedBorder dispInBk totalItems boardBottom">
                <div className="updateValue">{userId && _availableWeek}</div>
                <div className="wksClass">{userId && 'wks'}</div>
              </div>
              <div className="highValue dispInBk boardLeftBottom">
                <img width="15px" className="imagePosition imagePadding"
                     src={`${wbConfig.imageCdnUrl}/images/icons/high@3x.png`}/>
                {t('High')}
              </div>
              <div className="highValue dispInBk boardBottom">
                <img width="15px" className="imagePosition imagePadding"
                     src={`${wbConfig.imageCdnUrl}/images/icons/medium@3x.png`}/>
                {t('Medium')}
              </div>
              <div className="highValue  dispInBk boardBottom">
                <img width="15px" className="imagePosition imagePadding"
                     src={`${wbConfig.imageCdnUrl}/images/icons/low@3x.png`}/>
                {t('Low')}
              </div>
              <div className="highValue totalProgressValue dispInBk boardRightBottom AllPText">{t('All In Progress')}</div>
              <div className="statusValue statusBc dispInBk boardRightBottom">{t('Next')}</div>
              <div className="statusValue statusBc dispInBk boardRightBottom">{t('Backlog')}</div>
              <div className="statusValue statusBc dispInBk boardRightBottom">{t('Done')}</div>
              <div className="totalStatusValue statusBc totalItems dispInBk boardRightBottom">{t('Totals')}</div>
            </div>
            <div className="totalItemsBorder"/>
            {
              !userId && _workloadDetails.filterUserList.map((item, index) => {
                let doing_state_high = 0;
                let doing_state_medium = 0;
                let doing_state_low = 0;
                let doing_state_count = 0;
                let done_state_count = 0;
                let next_state_count = 0;
                let pause_state_count = 0;
                if (typeof item.userWorkload.doing_state !== 'undefined') {
                  doing_state_high = item.userWorkload.doing_state.high;
                  doing_state_medium = item.userWorkload.doing_state.medium;
                  doing_state_low = item.userWorkload.doing_state.low;
                  doing_state_count = item.userWorkload.doing_state.count;
                  done_state_count = item.userWorkload.done_state;
                  next_state_count = item.userWorkload.next_state;
                  pause_state_count = item.userWorkload.pause_state;
                }
                priority_high += doing_state_high;
                priority_medium += doing_state_medium;
                priority_low += doing_state_low;
                doing_state += doing_state_count;
                done_state += done_state_count;
                next_state += next_state_count;
                pause_state += pause_state_count;
                total_item = total_item + doing_state_count + next_state_count + pause_state_count + done_state_count;
                return (
                  <div className="dispInBk" key={`disp_in_bk_1_${index}`}>
                    <div className=" allocatedWidth dispInBk truncateText" title={item.name}>{item.name}</div>
                    <div
                      className="highValue highColor dispInBk highColorBoder">{doing_state_high == 0 ? '' : doing_state_high.toFixed(1)}</div>
                    <div
                      className="highValue mediumColor dispInBk">{doing_state_medium == 0 ? '' : doing_state_medium.toFixed(1)}</div>
                    <div
                      className="highValue lowColor dispInBk">{doing_state_low == 0 ? '' : doing_state_low.toFixed(1)}</div>
                    <div
                      className="highValue totalProgressValue dispInBk">{doing_state_count == 0 ? '' : doing_state_count.toFixed(1)}</div>
                    <div className="statusValue dispInBk">{next_state_count == 0 ? '' : next_state_count.toFixed(1)}</div>
                    <div
                      className="statusValue dispInBk">{pause_state_count == 0 ? '' : pause_state_count.toFixed(1)}</div>
                    <div className="statusValue dispInBk">{done_state_count == 0 ? '' : done_state_count.toFixed(1)}</div>
                    <div
                      className="totalStatusValue dispInBk">{(doing_state_count + next_state_count + pause_state_count + done_state_count).toFixed(1)}</div>
                  </div>
                );
              })
            }
            {
              userId && _wsData.length > 0 && _wsData.map((item, index) => {
                let doing_state_high = 0;
                let doing_state_medium = 0;
                let doing_state_low = 0;
                let doing_state_count = 0;
                let done_state_count = 0;
                let next_state_count = 0;
                let pause_state_count = 0;
                if (typeof item.doing_state !== 'undefined') {
                  doing_state_high = item.doing_state.high;
                  doing_state_medium = item.doing_state.medium;
                  doing_state_low = item.doing_state.low;
                  doing_state_count = item.doing_state.count;
                  done_state_count = item.done_state;
                  next_state_count = item.next_state;
                  pause_state_count = item.pause_state;
                }
                priority_high += doing_state_high;
                priority_medium += doing_state_medium;
                priority_low += doing_state_low;
                doing_state += doing_state_count;
                done_state += done_state_count;
                next_state += next_state_count;
                pause_state += pause_state_count;
                total_item = total_item + doing_state_count + next_state_count + pause_state_count + done_state_count;
                return (
                  <div className="dispInBk" key={`disp_in_bk_2_${index}`}>
                    <div className=" allocatedWidth dispInBk truncateText" title={item.ws_name}>{item.ws_name}</div>
                    <div
                      className="highValue highColor dispInBk highColorBoder">{doing_state_high == 0 ? '' : doing_state_high.toFixed(1)}</div>
                    <div
                      className="highValue mediumColor dispInBk">{doing_state_medium == 0 ? '' : doing_state_medium.toFixed(1)}</div>
                    <div
                      className="highValue lowColor dispInBk">{doing_state_low == 0 ? '' : doing_state_low.toFixed(1)}</div>
                    <div
                      className="highValue totalProgressValue dispInBk">{doing_state_count == 0 ? '' : doing_state_count.toFixed(1)}</div>
                    <div className="statusValue dispInBk">{next_state_count == 0 ? '' : next_state_count.toFixed(1)}</div>
                    <div
                      className="statusValue dispInBk">{pause_state_count == 0 ? '' : pause_state_count.toFixed(1)}</div>
                    <div className="statusValue dispInBk">{done_state_count == 0 ? '' : done_state_count.toFixed(1)}</div>
                    <div
                      className="totalStatusValue dispInBk">{(doing_state_count + next_state_count + pause_state_count + done_state_count).toFixed(1)}</div>
                  </div>
                );
              })
            }
            <div className="dispInBk totalItemsBorderNew">
              <div className="allocatedWidth totalItWidth totalItems dispInBk">Total Items</div>
              <div
                className="highValue highColor dispInBk highColorBoder">{priority_high == 0 ? '' : priority_high.toFixed(1)}</div>
              <div
                className="highValue mediumColor dispInBk">{priority_medium == 0 ? '' : priority_medium.toFixed(1)}</div>
              <div className="highValue lowColor dispInBk">{priority_low == 0 ? '' : priority_low.toFixed(1)}</div>
              <div
                className="highValue totalProgressValue dispInBk">{doing_state == 0 ? '' : doing_state.toFixed(1)}</div>
              <div className="totalStateValue dispInBk">{next_state == 0 ? '' : next_state.toFixed(1)}</div>
              <div className="totalStateValue dispInBk">{pause_state == 0 ? '' : pause_state.toFixed(1)}</div>
              <div className="totalStateValue doneBorder dispInBk">{done_state == 0 ? '' : done_state.toFixed(1)}</div>
              <div className="totalStatusValue dispInBk">{total_item.toFixed(1)}</div>
            </div>
          </div>
        </div>
      </StyledModal>
    </ThemeProvider>
  );
}

export {
  MemberCapacity,
}